import React, { useEffect, useState } from 'react'
import { GeoIpDataStats } from '../../../services'
import { Globe, MapPin, RefreshCw } from 'lucide-react'

function GeoStats() {
  const [geoStats, setGeoStats] = useState({})
  const [loading, setLoading] = useState(true)

  const fetchGeoStats = async () => {
    try {
      setLoading(true)
      const res = await GeoIpDataStats()
      setGeoStats(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchGeoStats()
  }, [])

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-white rounded-lg shadow-md p-6 animate-pulse">
            <div className="h-12 bg-gray-200 rounded mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-2/3"></div>
          </div>
        ))}
      </div>
    )
  }

  const stats = [
    {
      title: 'Total Cached IPs',
      value: geoStats.total_cached_ips?.toLocaleString() || '0',
      icon: Globe,
      color: 'bg-cyan-500',
      lightColor: 'bg-cyan-50',
      textColor: 'text-cyan-600'
    },
    {
      title: 'Unique Countries',
      value: geoStats.unique_countries?.toLocaleString() || '0',
      icon: MapPin,
      color: 'bg-emerald-500',
      lightColor: 'bg-emerald-50',
      textColor: 'text-emerald-600'
    },
    {
      title: 'Last Refresh',
      value: geoStats.last_refresh 
        ? new Date(geoStats.last_refresh).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        : 'N/A',
      icon: RefreshCw,
      color: 'bg-violet-500',
      lightColor: 'bg-violet-50',
      textColor: 'text-violet-600'
    }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      {stats.map((stat, index) => {
        const Icon = stat.icon
        return (
          <div 
            key={index}
            className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 group"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`${stat.lightColor} p-3 rounded-lg group-hover:scale-110 transition-transform duration-300`}>
                <Icon className={`w-6 h-6 ${stat.textColor}`} />
              </div>
            </div>
            <h3 className="text-gray-500 text-sm font-medium mb-1">{stat.title}</h3>
            <p className={`text-3xl font-bold ${stat.textColor}`}>{stat.value}</p>
          </div>
        )
      })}
    </div>
  )
}

export default GeoStats